import script from "./DataVersorgung.vue?vue&type=script&setup=true&lang=js"
export * from "./DataVersorgung.vue?vue&type=script&setup=true&lang=js"

import "./DataVersorgung.vue?vue&type=style&index=0&id=5f013f91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f013f91"]])

export default __exports__